import axios from "axios";

const errorHandeler = (error) => {
  if (error.response) {
    // Запрос был сделан, и сервер ответил кодом состояния, который
    // выходит за пределы 2xx
    console.log(error.response.data);
    console.log(error.response.status);
    return { data: error.response.data, status: error.response.status };
  } else if (error.request) {
    // Запрос был сделан, но ответ не получен
    // `error.request`- это экземпляр XMLHttpRequest в браузере и экземпляр
    // http.ClientRequest в node.js
    console.log(error.request);
    return error.request;
  } else {
    // Произошло что-то при настройке запроса, вызвавшее ошибку
    console.log("Error", error.message);
  }
  console.log(error.config);
};

const normalizeRes = (res) => {
  const { data, status } = res;

  return { data, status };
};

const getData = async (url) => {
  const res = await axios.get(url).catch((err) => errorHandeler(err));
  return normalizeRes(res);
};

const postData = async (url, data) => {
  const res = await axios.post(url, data).catch((err) => errorHandeler(err));
  return normalizeRes(res);
};
const putData = async (url, data) => {
  const res = await axios.put(url, data).catch((err) => errorHandeler(err));
  return normalizeRes(res);
};

const deleteData = async (url, data) => {
  const res = await axios.delete(url, data).catch((err) => errorHandeler(err));

  return normalizeRes(res);
};

export const orderStatus = {
  0: { text: "Ожидает", color: "info" },
  1: { text: "Одобрено", color: "success" },
  2: { text: "Внимание", color: "warning" },
  3: { text: "Отклонено", color: "error" },
};

export { errorHandeler, normalizeRes, getData, postData, putData, deleteData };
